import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideKeycloakAngular } from "./app.keycloak";
import { NoAuthInterceptor } from "./interceptors/no-auth.interceptor";
import { ErrorService } from "./service/error.service";
import { KeycloakAuthInterceptor } from "./interceptors/keycloak-auth.interceptor";
import { provideDateFnsAdapter } from "@angular/material-date-fns-adapter";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { fr, enGB } from 'date-fns/locale';
import { registerLocaleData } from "@angular/common";
import localeFr from '@angular/common/locales/fr';
import { provideTranslation } from "./app.translate";

registerLocaleData(localeFr, 'fr-FR');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: navigator.language.startsWith('fr') ? fr : enGB },
    { provide: ErrorHandler, useClass: ErrorService },
    { provide: HTTP_INTERCEPTORS, useClass: KeycloakAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NoAuthInterceptor, multi: true },
    provideTranslation(),
    provideKeycloakAngular(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideDateFnsAdapter(),
  ]
};